// import React, { useState, useEffect, useCallback, useMemo } from "react";
// import AddFineModal from "../utils/AddFineModal";
// import { FineService } from "../services/addNewFineService";
// import Sidebar from "./Sidebar";
// import PaidUnpaidManager from "./PaidUnpaidManager";
// import Swal from "sweetalert2";
// import {
//   FaCalendarCheck,
//   FaPlus,
//   FaPiggyBank,
//   FaWallet,
//   FaCheckCircle,
//   FaSync,
//   FaDownload,
//   FaSearch,
// } from "react-icons/fa";
// import "./FinesPageNew.css";

// /* ─────────────────────────────────────────────
//    Skeleton card
// ───────────────────────────────────────────── */
// const SkeletonCard = () => (
//   <div className="stat-card primary" style={{ cursor: "default" }}>
//     <div
//       className="skeleton"
//       style={{ width: 44, height: 44, borderRadius: 12, marginBottom: 14 }}
//     />
//     <div
//       className="skeleton"
//       style={{ width: "50%", height: 12, marginBottom: 8 }}
//     />
//     <div className="skeleton" style={{ width: "75%", height: 28 }} />
//     <div className="mini-bar" style={{ marginTop: 14 }}>
//       <div className="mini-bar-fill" style={{ width: "0%" }} />
//     </div>
//   </div>
// );

// /* ─────────────────────────────────────────────
//    Main component
// ───────────────────────────────────────────── */
// const FinesPage = () => {
//   const [showModal, setShowModal] = useState(false);
//   const [users, setUsers] = useState([]);
//   const [fines, setFines] = useState([]);
//   const [showPaidUnpaidModal, setShowPaidUnpaidModal] = useState(false);
//   const [summaryData, setSummaryData] = useState({
//     totalFines: 0,
//     pendingFines: 0,
//     paidFines: 0,
//   });
//   const [loading, setLoading] = useState(false);
//   const [spinning, setSpinning] = useState(false);
//   const [toast, setToast] = useState(null);
//   const [search, setSearch] = useState("");
//   const [sortCol, setSortCol] = useState("date");
//   const [sortDir, setSortDir] = useState("desc");
//   const [activeFilter, setActiveFilter] = useState(null); // null | "total" | "pending" | "paid"

//   const showToast = (msg) => {
//     setToast(msg);
//     setTimeout(() => setToast(null), 3000);
//   };

//   const fetchData = useCallback(async (isRefresh = false) => {
//     if (isRefresh) setSpinning(true);
//     else setLoading(true);
//     try {
//       const userList = await FineService.fetchUsers();
//       setUsers(userList);

//       const { finesList, totalFinesAmount, pendingFinesAmount } =
//         await FineService.fetchFines(userList);
//       setFines(finesList);

//       const paidAmount = totalFinesAmount - pendingFinesAmount;
//       setSummaryData({
//         totalFines: totalFinesAmount,
//         pendingFines: pendingFinesAmount,
//         paidFines: paidAmount,
//       });
//       await FineService.updateHistory(totalFinesAmount, pendingFinesAmount);

//       if (isRefresh) showToast("Data refreshed successfully");
//     } catch (err) {
//       console.error("Error fetching fines data:", err);
//       Swal.fire("Error", "Failed to load data", "error");
//     } finally {
//       setLoading(false);
//       setSpinning(false);
//     }
//   }, []);

//   useEffect(() => {
//     fetchData();
//   }, [fetchData]);

//   /* ── Sorting ── */
//   const toggleSort = (col) => {
//     if (sortCol === col) setSortDir((d) => (d === "asc" ? "desc" : "asc"));
//     else {
//       setSortCol(col);
//       setSortDir("asc");
//     }
//   };

//   /* ── Filtering + Searching ── */
//   const filteredFines = useMemo(() => {
//     let list = [...fines];

//     if (activeFilter === "pending") list = list.filter((f) => !f.isPaid);
//     else if (activeFilter === "paid") list = list.filter((f) => f.isPaid);

//     if (search.trim()) {
//       const q = search.toLowerCase();
//       list = list.filter(
//         (f) =>
//           (f.userName || "").toLowerCase().includes(q) ||
//           (f.reason || "").toLowerCase().includes(q),
//       );
//     }

//     list.sort((a, b) => {
//       let va = a[sortCol],
//         vb = b[sortCol];
//       if (sortCol === "amount") {
//         va = +va;
//         vb = +vb;
//       }
//       if (sortCol === "date") {
//         va = new Date(va);
//         vb = new Date(vb);
//       }
//       if (va < vb) return sortDir === "asc" ? -1 : 1;
//       if (va > vb) return sortDir === "asc" ? 1 : -1;
//       return 0;
//     });

//     return list;
//   }, [fines, search, sortCol, sortDir, activeFilter]);

//   /* ── CSV export ── */
//   const exportCSV = () => {
//     const header = ["Name", "Reason", "Amount (PKR)", "Date", "Status"];
//     const rows = filteredFines.map((f) => [
//       f.userName,
//       f.reason,
//       f.amount,
//       f.date ? new Date(f.date).toLocaleDateString() : "",
//       f.isPaid ? "Paid" : "Unpaid",
//     ]);
//     const csv = [header, ...rows].map((r) => r.join(",")).join("\n");
//     const a = document.createElement("a");
//     a.href = "data:text/csv," + encodeURIComponent(csv);
//     a.download = "fines_export.csv";
//     a.click();
//   };

//   const paidPct = summaryData.totalFines
//     ? (summaryData.paidFines / summaryData.totalFines) * 100
//     : 0;
//   const pendingPct = summaryData.totalFines
//     ? (summaryData.pendingFines / summaryData.totalFines) * 100
//     : 0;

//   const initials = (name = "") =>
//     name
//       .split(" ")
//       .map((w) => w[0])
//       .join("")
//       .slice(0, 2)
//       .toUpperCase();

//   return (
//     <div className="fines-wrapper">
//       <Sidebar />

//       <div className="fines-main">
//         {/* ── Header ── */}
//         <div className="page-header">
//           <div className="page-title">
//             <span className="icon-wrap">
//               <FaCalendarCheck />
//             </span>
//             Fine Management
//           </div>
//           <button
//             className={`refresh-btn${spinning ? " spinning" : ""}`}
//             onClick={() => fetchData(true)}
//             disabled={loading}
//             title="Refresh data"
//           >
//             <FaSync /> Refresh
//           </button>
//         </div>

//         {/* ── Summary cards ── */}
//         <div className="summary-grid">
//           {loading ? (
//             <>
//               <SkeletonCard />
//               <SkeletonCard />
//               <SkeletonCard />
//             </>
//           ) : (
//             <>
//               <div
//                 className={`stat-card primary${activeFilter === "total" ? " active-filter" : ""}`}
//                 onClick={() =>
//                   setActiveFilter((f) => (f === "total" ? null : "total"))
//                 }
//                 title="Show all fines"
//               >
//                 <div className="stat-icon">
//                   <FaPiggyBank />
//                 </div>
//                 <div className="stat-label">Total Fines</div>
//                 <div className="stat-value">
//                   PKR {summaryData.totalFines.toFixed(2)}
//                 </div>
//                 <div className="mini-bar">
//                   <div className="mini-bar-fill" style={{ width: "100%" }} />
//                 </div>
//               </div>

//               <div
//                 className={`stat-card danger${activeFilter === "pending" ? " active-filter" : ""}`}
//                 onClick={() =>
//                   setActiveFilter((f) => (f === "pending" ? null : "pending"))
//                 }
//                 title="Filter unpaid fines"
//               >
//                 <div className="stat-icon">
//                   <FaWallet />
//                 </div>
//                 <div className="stat-label">Pending Fines</div>
//                 <div className="stat-value">
//                   PKR {summaryData.pendingFines.toFixed(2)}
//                 </div>
//                 <div className="mini-bar">
//                   <div
//                     className="mini-bar-fill"
//                     style={{ width: `${pendingPct}%` }}
//                   />
//                 </div>
//               </div>

//               <div
//                 className={`stat-card success${activeFilter === "paid" ? " active-filter" : ""}`}
//                 onClick={() =>
//                   setActiveFilter((f) => (f === "paid" ? null : "paid"))
//                 }
//                 title="Filter paid fines"
//               >
//                 <div className="stat-icon">
//                   <FaCheckCircle />
//                 </div>
//                 <div className="stat-label">Paid Fines</div>
//                 <div className="stat-value">
//                   PKR {summaryData.paidFines.toFixed(2)}
//                 </div>
//                 <div className="mini-bar">
//                   <div
//                     className="mini-bar-fill"
//                     style={{ width: `${paidPct}%` }}
//                   />
//                 </div>
//               </div>
//             </>
//           )}
//         </div>

//         {/* ── Toolbar ── */}
//         <div className="toolbar">
//           <div className="search-wrap">
//             <FaSearch />
//             <input
//               className="search-input"
//               placeholder="Search by name or reason…"
//               value={search}
//               onChange={(e) => setSearch(e.target.value)}
//             />
//           </div>

//           <button
//             className="btn-fines btn-primary-fines"
//             onClick={() => setShowModal(true)}
//             disabled={loading}
//           >
//             <FaPlus /> Add New Fine
//           </button>

//           <button
//             className="btn-fines btn-warn-fines"
//             onClick={() => setShowPaidUnpaidModal(true)}
//             disabled={loading}
//           >
//             <span>💰</span> Paid / Unpaid
//           </button>

//           <button
//             className="btn-fines btn-export-fines"
//             onClick={exportCSV}
//             disabled={loading || filteredFines.length === 0}
//             title="Export visible rows to CSV"
//           >
//             <FaDownload /> Export CSV
//           </button>
//         </div>
//       </div>

//       {/* ── Modals ── */}
//       <PaidUnpaidManager
//         show={showPaidUnpaidModal}
//         setShow={setShowPaidUnpaidModal}
//         fines={fines}
//         users={users}
//         fetchData={fetchData}
//       />
//       <AddFineModal
//         showModal={showModal}
//         setShowModal={setShowModal}
//         users={users}
//         fetchData={fetchData}
//       />

//       {/* ── Toast ── */}
//       {toast && (
//         <div className="toast-bar">
//           <FaCheckCircle /> {toast}
//         </div>
//       )}
//     </div>
//   );
// };

// export default FinesPage;




import React, { useState, useEffect, useCallback } from "react";
import { FaCalendarCheck, FaPlus, FaPiggyBank, FaWallet, FaCheckCircle, FaSync, } from "react-icons/fa";
import AddFineModal from "../utils/AddFineModal";
import { FineService } from "../services/addNewFineService";
import Sidebar from "./Sidebar";
import PaidUnpaidManager from "./PaidUnpaidManager";
import Swal from "sweetalert2";
import "./FinesPageNew.css";

const CARDS = [
  { key: "total",   label: "Total Fines",   dataKey: "totalFines",   icon: <FaPiggyBank />,  cls: "primary" },
  { key: "pending", label: "Pending Fines",  dataKey: "pendingFines", icon: <FaWallet />,     cls: "danger"  },
  { key: "paid",    label: "Paid Fines",     dataKey: "paidFines",    icon: <FaCheckCircle />,cls: "success" },
];

export default function FinesPage() {
  const [showModal,          setShowModal]          = useState(false);
  const [showPaidUnpaid,     setShowPaidUnpaid]     = useState(false);
  const [users,              setUsers]              = useState([]);
  const [fines,              setFines]              = useState([]);
  const [summary,            setSummary]            = useState({ totalFines: 0, pendingFines: 0, paidFines: 0 });
  const [loading,            setLoading]            = useState(false);
  const [spinning,           setSpinning]           = useState(false);
  const [toast,              setToast]              = useState(null);
  // const [search,             setSearch]             = useState("");
  // const [sortCol,            setSortCol]            = useState("date");
  // const [sortDir,            setSortDir]            = useState("desc");
  const [activeFilter,       setActiveFilter]       = useState(null);

  /* ── fetch ── */
  const fetchData = useCallback(async (isRefresh = false) => {
    isRefresh ? setSpinning(true) : setLoading(true);
    try {
      const userList = await FineService.fetchUsers();
      const activeUsers = userList.filter(user => user.status === "Active");

      setUsers(activeUsers);
      const { finesList, totalFinesAmount, pendingFinesAmount } = await FineService.fetchFines(userList);
      setFines(finesList);
      const paidFines = totalFinesAmount - pendingFinesAmount;
      setSummary({ totalFines: totalFinesAmount, pendingFines: pendingFinesAmount, paidFines });
      await FineService.updateHistory(totalFinesAmount, pendingFinesAmount);
      if (isRefresh) { setToast("Data refreshed"); setTimeout(() => setToast(null), 3000); }
    } catch {
      Swal.fire("Error", "Failed to load data", "error");
    } finally {
      setLoading(false); setSpinning(false);
    }
  }, []);

  useEffect(() => { fetchData(); }, [fetchData]);

  /* ── sort ── */
  // const toggleSort = (col) => {
  //   setSortCol(col);
  //   setSortDir(d => col === sortCol && d === "asc" ? "desc" : "asc");
  // };

  /* ── filtered list ── */
  // const filteredFines = useMemo(() => {
  //   let list = fines.filter(f =>
  //     (activeFilter === "pending" ? !f.isPaid : activeFilter === "paid" ? f.isPaid : true)
  //   );
  //   if (search.trim()) {
  //     const q = search.toLowerCase();
  //     list = list.filter(f => f.userName?.toLowerCase().includes(q) || f.reason?.toLowerCase().includes(q));
  //   }
  //   return list.sort((a, b) => {
  //     const va = sortCol === "amount" ? +a[sortCol] : sortCol === "date" ? new Date(a[sortCol]) : a[sortCol];
  //     const vb = sortCol === "amount" ? +b[sortCol] : sortCol === "date" ? new Date(b[sortCol]) : b[sortCol];
  //     return (va < vb ? -1 : va > vb ? 1 : 0) * (sortDir === "asc" ? 1 : -1);
  //   });
  // }, [fines, search, sortCol, sortDir, activeFilter]);

  /* ── CSV ── */
  // const exportCSV = () => {
  //   const rows = [["Name","Reason","Amount (PKR)","Date","Status"],
  //     ...filteredFines.map(f => [f.userName, f.reason, f.amount,
  //       f.date ? new Date(f.date).toLocaleDateString() : "", f.isPaid ? "Paid" : "Unpaid"])];
  //   const a = Object.assign(document.createElement("a"), {
  //     href: "data:text/csv," + encodeURIComponent(rows.map(r => r.join(",")).join("\n")),
  //     download: "fines_export.csv"
  //   });
  //   a.click();
  // };

  return (
    <div className="fines-wrapper">
      <Sidebar />

      <div className="fines-main">
        {/* Header */}
        <div className="page-header">
          <div className="page-title"><span className="icon-wrap"><FaCalendarCheck /></span> Fine Management</div>
          <button className={`refresh-btn${spinning ? " spinning" : ""}`} onClick={() => fetchData(true)} disabled={loading}>
            <FaSync /> Refresh
          </button>
        </div>

        {/* Summary Cards */}
        <div className="summary-grid">
          {CARDS.map(({ key, label, dataKey, icon, cls }) => {
            const val  = summary[dataKey];
            const pct  = summary.totalFines ? (val / summary.totalFines) * 100 : 0;
            return loading
              ? <div key={key} className="stat-card primary" style={{ cursor: "default" }}><div className="skeleton" style={{ width: 44, height: 44, borderRadius: 12, marginBottom: 14 }} /><div className="skeleton" style={{ width: "50%", height: 12, marginBottom: 8 }} /><div className="skeleton" style={{ width: "75%", height: 28 }} /></div>
              : <div key={key} className={`stat-card ${cls}${activeFilter === key ? " active-filter" : ""}`} onClick={() => setActiveFilter(f => f === key ? null : key)}>
                  <div className="stat-icon">{icon}</div>
                  <div className="stat-label">{label}</div>
                  <div className="stat-value">PKR {val.toFixed(2)}</div>
                  <div className="mini-bar"><div className="mini-bar-fill" style={{ width: `${key === "total" ? 100 : pct}%` }} /></div>
                </div>;
          })}
        </div>

        {/* Toolbar */}
        <div className="toolbar">
          {/* <div className="search-wrap">
            <FaSearch />
            <input className="search-input" placeholder="Search by name or reason…" value={search} onChange={e => setSearch(e.target.value)} />
          </div> */}
          <button className="btn-fines btn-primary-fines" onClick={() => setShowModal(true)} disabled={loading}><FaPlus /> Add New Fine</button>
          <button className="btn-fines btn-warn-fines"    onClick={() => setShowPaidUnpaid(true)} disabled={loading}>💰 Paid / Unpaid</button>
          {/* <button className="btn-fines btn-export-fines"  onClick={exportCSV} disabled={loading || !filteredFines.length}><FaDownload /> Export CSV</button> */}
        </div>
      </div>

      <PaidUnpaidManager show={showPaidUnpaid} setShow={setShowPaidUnpaid} fines={fines} users={users} fetchData={fetchData} />
      <AddFineModal showModal={showModal} setShowModal={setShowModal} users={users} fetchData={fetchData} />

      {toast && <div className="toast-bar"><FaCheckCircle /> {toast}</div>}
    </div>
  );
}